

import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ScheduleJobService } from 'tnx-admin-service/schedulejob/services';
import { ScheduleTriggerService } from 'tnx-admin-service/scheduletrigger/services';
import { TriggerHistoryConstants } from 'tnx-admin-service/scheduletriggerhistory/constants';
import { ScheduleTriggerHistoryService } from 'tnx-admin-service/scheduletriggerhistory/services';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema } from 'tnx-shared';

@Component({
    selector: 'scheduletriggerhistory',
    templateUrl: './scheduletriggerhistory.component.html',
    styleUrls: ['./scheduletriggerhistory.component.scss'],
    providers: [ComponentContextService],
})
export class ScheduleTriggerHistoryComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _scheduleJobService: ScheduleJobService,
        protected _scheduleTriggerService: ScheduleTriggerService,
        protected _scheduleTriggerHistoryService: ScheduleTriggerHistoryService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        // this.setting.columnSetting.groupField = 'stridTrigger';
        this.setting.baseService = this._scheduleTriggerHistoryService;
        this.setting.columnSetting.sortField = 'created';
        this.setting.columnSetting.sortDir = -1;
        this.setting.title = 'Nhật ký công việc';
        this.setting.objectName = 'nhật ký công việc';
        this.setting.popupSize.height = 450;
        this.setting.modelSchemas = [
            new ModelSchema({
                field: 'idTrigger',
                name: 'Lịch trình',
                fullName: 'Lịch trình',
                description: 'Lịch trình',
            }),
            new ModelSchema({
                field: 'callbackStatus',
                name: 'Trạng thái callback',
                fullName: 'Trạng thái callback',
                description: 'Trạng thái callback',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'timeoutStatus',
                name: 'Trạng thái timeout',
                fullName: 'Trạng thái timeout',
                description: 'Trạng thái timeout',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'currentTimeout',
                name: 'Thời gian timeout (giây)',
                fullName: 'Thời gian timeout (giây)',
                description: 'Thời gian timeout (giây)',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'data',
                name: 'Dữ liệu gửi kèm (json)',
                fullName: 'Dữ liệu gửi kèm (json)',
                description: 'Dữ liệu gửi kèm (json)',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'endTriggerAt',
                name: 'Thời gian phản hồi',
                fullName: 'Lịch trình kết thúc từ thời gian nào',
                description: 'Lịch trình nhận phản hồi lúc nào. Nếu quá timeout thì căn cứ tự động ngắt luôn Lịch trình này',
                dataType: 'datetime',
            }),
            new ModelSchema({
                field: 'errorMessage',
                name: 'Lỗi',
                fullName: 'Ghi lại exception xảy ra (nếu có)',
                description: 'Ghi lại exception xảy ra (nếu có)',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'idTrigger',
                name: 'Lịch trình',
                fullName: 'Lịch trình',
                description: 'Lịch trình',
            }),
            new ModelSchema({
                field: 'startTriggerAt',
                name: 'Thời gian chạy',
                fullName: 'Lịch trình bắt đầu từ thời gian nào',
                description: 'Lịch trình bắt đầu từ thời gian nào',
                dataType: 'datetime',
            }),
            new ModelSchema({
                field: 'created',
                name: 'Thời gian tạo',
                fullName: 'Thời gian tạo',
                description: 'Thời gian tạo',
                dataType: 'datetime',
            }),

        ];

        this.setting.cols = [
            new ColumnSchemaBase({
                field: 'idTrigger',
                baseService: this._scheduleTriggerService,
                displayField: 'name',
                valueField: 'id'
            }),
            new ColumnSchemaBase({
                field: 'callbackStatus',
                dataType: 'callbackStatus',
                dataTypeRefField: 'callbackStatus',
                dataSource: TriggerHistoryConstants.TriggerHistoryCallbackStatusDataSource,
                displayField: 'label',
                valueField: 'value'
            }),
            new ColumnSchemaBase({
                field: 'timeoutStatus',
                dataType: 'timeoutStatus',
                dataTypeRefField: 'timeoutStatus',
                dataSource: TriggerHistoryConstants.TriggerHistoryTimeoutStatusDataSource,
                displayField: 'label',
                valueField: 'value'
            }),
            new ColumnSchemaBase({ field: 'currentTimeout' }),
            new ColumnSchemaBase({ field: 'data' }),
            new ColumnSchemaBase({
                field: 'startTriggerAt',
                format: 'normal'
            }),
            new ColumnSchemaBase({
                field: 'endTriggerAt',
                format: 'normal'
            }),
            new ColumnSchemaBase({
                field: 'errorMessage',
                fullTextSearch: true
            }),
            new ColumnSchemaBase({
                field: 'created',
                format: 'normal'
            }),

        ];
        super.ngOnInit();
    }

    async afterGetData(): Promise<void> {
        for (const item of this.model.dataSource) {
            item.hiddenEdit = true;

            item.classcallbackStatus = TriggerHistoryConstants.TriggerHistoryCallbackStatusDataSource
                .filter(o => o.value == item.callbackStatus)
                .map(o => o.styleClass).pop();
            item.classtimeoutStatus = TriggerHistoryConstants.TriggerHistoryTimeoutStatusDataSource
                .filter(o => o.value == item.timeoutStatus)
                .map(o => o.styleClass).pop();
        }
        // console.table(this.model.dataSource);
    }
}
